import React from 'react';
import clsx from 'clsx';
import { withFormsy } from 'formsy-react';
import { Checkbox, Chip, FormControlLabel, Grid, styled, Typography } from '@mui/material';
import { type FieldProps } from './components/BaseTextField';

type BooleanFieldProps = Omit<FieldProps<boolean>, 'startAdornment' | 'endAdornment'>;

const Root = styled('div')(({ theme }) => ({
	height: '100%',
	maxHeight: '51.69px',
	paddingLeft: 12,
	paddingRight: 12,
	'&.BooleanField-root-logs': {
		borderBottom: 0,
		borderTopLeftRadius: 4,
		borderTopRightRadius: 4,
		cursor: 'pointer',
		backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)',
		'&:hover': {
			backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)'
		}
	}
}));

function BooleanField(props: BooleanFieldProps) {
	const hasLogs = props.logProps?.hasLogs(props.name);

	function handleChange(event) {
		if (props.beforeChange) props.beforeChange(event.target.checked);
		props.sendChange(props.name, event.target.checked);
		if (props.afterChange) props.afterChange(event.target.checked);
	}

	return (
		<Root
			className={clsx(hasLogs && 'BooleanField-root-logs', props.className)}
			onClick={() =>
				props.logProps?.openLogsDialog(props.name, props.label, fieldValue => (fieldValue ? 'True' : 'False'))
			}
		>
			<Grid container justifyContent="space-between" alignItems="center" className="h-full">
				<Grid size="grow">
					<FormControlLabel
						className="w-full"
						label={props.label}
						control={<Checkbox checked={!!props.value} onChange={handleChange} />}
						disabled={!props.isEdit}
					/>
				</Grid>
				{hasLogs && (
					<Grid>
						<Chip label={props.logProps?.logsCounters[props.name]} size="small" color="primary" />
					</Grid>
				)}
			</Grid>
		</Root>
	);
}

export default React.memo(withFormsy(BooleanField));
